<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="!localGame" >
      <v-flex xs12>
       <v-card  style="border-radius: 0;">
        <v-card-text class="text-xs-center">
          <v-progress-circular :width="6" :size="60" indeterminate color="primary"></v-progress-circular>
        </v-card-text>
      </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12>
        <toolbar :menu="menu" :game="localGame" @menu="menu = true"></toolbar>
      </v-flex>
      <v-flex xs3 v-if="menu">
        <nav-bar :game="localGame" @close="menu = false"></nav-bar>
      </v-flex>
      <v-flex :class="{'xs9': menu, 'xs12' : !menu}">
        <v-slide-y-transition mode="out-in">
          <router-view :key="$route.path"></router-view>
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Toolbar from './layout/Toolbar'
import NavBar from './layout/Navbar'
export default {
  name: "Ingame",
  components: {
    Toolbar,
    NavBar
  },
  data() {
    return {
      localGame: null,
      menu: true
    }
  },
  async mounted() {
    this.localGame = null
    let model = await this.$store.dispatch("games/getOne", this.$route.params.game);
    this.$socket.emit('subscribe', this.$route.params.game)
    this.localGame = Object.assign({}, model);
  },
  beforeDestroy() {
    this.$socket.emit('unsubscribe', this.$store.state.games.current._id)
  },
  methods: {
  },
  computed: {}
};
</script>

